var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M71.4046 30.735C71.0671 27.0225 70.0771 23.0625 62.8546 23.0625H34.1446C26.9221 23.0625 25.9546 27.0225 25.5946 30.735L24.3346 44.4375C24.1771 46.1475 24.7396 47.8575 25.9096 49.14C27.1021 50.445 28.7896 51.1875 30.5896 51.1875H34.8196C38.4646 51.1875 39.1621 49.095 39.6121 47.7225L40.0621 46.3725C40.5796 44.82 40.7146 44.4375 42.7396 44.4375H54.2596C56.2846 44.4375 56.3521 44.6625 56.9371 46.3725L57.3871 47.7225C57.8371 49.095 58.5346 51.1875 62.1796 51.1875H66.4096C68.1871 51.1875 69.8971 50.445 71.0896 49.14C72.2596 47.8575 72.8221 46.1475 72.6646 44.4375L71.4046 30.735Z",
    fill: "#2FF77A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75 16.3122H66.5C66.4775 16.3122 66.4775 16.3122 66.455 16.3122L65.6 12.2397C64.79 8.30219 63.1025 4.67969 56.3975 4.67969H50.1875H46.8125H40.6025C33.8975 4.67969 32.21 8.30219 31.4 12.2397L30.545 16.3122C30.5225 16.3122 30.5225 16.3122 30.5 16.3122H28.25C27.3275 16.3122 26.5625 17.0772 26.5625 17.9997C26.5625 18.9222 27.3275 19.6872 28.25 19.6872H29.8475L28.9025 24.1872C30.1175 23.4897 31.805 23.0622 34.145 23.0622H62.855C65.195 23.0622 66.8825 23.4897 68.0975 24.1872L67.1525 19.6872H68.75C69.6725 19.6872 70.4375 18.9222 70.4375 17.9997C70.4375 17.0772 69.6725 16.3122 68.75 16.3122Z",
    fill: "#2FF77A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.75 35.4375H35C34.0775 35.4375 33.3125 34.6725 33.3125 33.75C33.3125 32.8275 34.0775 32.0625 35 32.0625H41.75C42.6725 32.0625 43.4375 32.8275 43.4375 33.75C43.4375 34.6725 42.6725 35.4375 41.75 35.4375Z",
    fill: "#2FF77A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 35.4375H55.25C54.3275 35.4375 53.5625 34.6725 53.5625 33.75C53.5625 32.8275 54.3275 32.0625 55.25 32.0625H62C62.9225 32.0625 63.6875 32.8275 63.6875 33.75C63.6875 34.6725 62.9225 35.4375 62 35.4375Z",
    fill: "#2FF77A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5108_93995)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41.5,
    r: 9.5,
    fill: "#2FF77A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5108_93995",
    x: 0.5,
    y: 1,
    width: 81,
    height: 81,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5,
    result: "effect1_foregroundBlur_5108_93995"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/carIcon.403a006a6553d7d215b93da4a79f9a58.svg";
export { ForwardRef as ReactComponent };